import { Button, Col, DatePicker, Flex, Form, Row, Space } from 'antd';
import React from 'react';
import AppSelect from '../AppSelect';
import AppSearch from '../AppSearch';
import { isArray, isString } from 'lodash';
import dayjs from 'dayjs';
import AppRangePicker from '../AppRangePicker';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';

const valueFormat = 'YYYY-MM-DD';
const valueMonthFormat = 'YYYY-MM';
const displayFormat = 'DD/MM/YYYY';
const displayMonthFormat = 'MM/YYYY';

function AppTableQuery({
  hasActionButtons = true,
  hasSearch = true,
  hasFilter = true,
  hasDatePicker = false,
  rangePicker = false,
  searchPlaceholder,
  filterPlaceholder = 'Filter',
  filterOptions = [],
  filterLabel = 'Filter',
  defaultFilterOptions = filterOptions[0]?.value,
  selectedFilter,
  setSelectedFilter,
  time,
  setTime,
  timeLabel = 'Time',
  timePlaceholder = ['Start time', 'End time'] || 'Time',
  picker = 'date',
  dateLimit = {
    value: 1,
    unit: 'year',
  },
  customFilter,
  customDatePicker,
  customActionButtons,
  searchValue,
  setSearchValue,
  handleQuery,
  handleReset,
  loading = false,
  allowClear = true,
  className = '',
  canDisableFutureDate = true,
  flexProps = {},
  colSpans,
  children,
}) {
  const isBreak = useMediaQuery(`(max-width: 1280px) and (min-width: 992px)`);
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);
  const isTablet = useMediaQuery(`(max-width: ${mediaQueryPoints.mdPlus}px)`);

  const handleOnOk = (dates, formatted) => {
    if (dates) {
      if (rangePicker && formatted) {
        // For RangePicker, dates is an array of two dayjs objects
        setTime?.(formatted);
      } else if (!rangePicker) {
        // For single DatePicker
        if (picker === 'month') {
          setTime?.(dayjs(dates).format(valueMonthFormat));
        } else {
          setTime?.(dayjs(dates).format(valueFormat));
        }
      }
    } else {
      setTime(null);
    }
  };

  const renderColSpans = () => {
    if (isMobile) {
      return [24, 24, 24];
    } else if (isTablet) {
      return [6, 8, 10];
    } else {
      return [6, 6, 8];
    }
  };

  return (
    <Space
      direction="vertical"
      className={`w-full bg-white p-4 pt-2 rounded-md ${className} gap-1 justify-between`}
    >
      <Flex
        justify="space-between"
        align="flex-end"
        {...flexProps}
        vertical={isMobile}
        gap={isMobile ? 12 : 8}
      >
        {/* <div className="flex items-center w-fit gap-2">
          {hasSearch && (
            <Space direction="vertical" className="w-fit">
              <p className="font-medium">Search</p>
              <AppSearch
                placeholder={searchPlaceholder}
                value={searchValue}
                onChange={(val) => {
                  setSearchValue(val);
                }}
                className={isBreak ? 'max-w-[250px]' : 'max-w-[350px]'}
              />
            </Space>
          )}

          {hasFilter &&
            (customFilter ? (
              customFilter
            ) : (
              <Space direction="vertical" className="w-fit">
                <p className="font-medium">{filterLabel}</p>
                <AppSelect
                  items={filterOptions}
                  defaultValue={defaultFilterOptions}
                  placeholder={filterPlaceholder}
                  title={filterPlaceholder}
                  onChange={(val) => {
                    setSelectedFilter(val);
                  }}
                  className={`${isBreak ? 'w-[150px]' : 'w-[200px]'}`}
                  value={selectedFilter}
                />
              </Space>
            ))}

          {hasDatePicker && (
            <div className="flex items-center gap-2">
              <Space direction="vertical" className="w-fit">
                <p className="font-medium">{timeLabel}</p>
                {!rangePicker ? (
                  <DatePicker
                    format={displayFormat}
                    value={time ? dayjs(time) : null}
                    placeholder={isString(timePlaceholder) ? timePlaceholder : ''}
                    className={isBreak ? 'max-w-[150px]' : 'max-w-[200px]'}
                    onChange={(date) => handleOnOk(date)}
                    allowClear={allowClear}
                    disabledDate={(currentDate) => {
                      if (currentDate.isAfter(dayjs(), 'day') && canDisableFutureDate) {
                        return true;
                      }
                      return false;
                    }}
                  />
                ) : (
                  <AppRangePicker
                    date={isArray(time) && time.length === 2 ? time : null}
                    onOk={handleOnOk}
                    isMax1Year={isMax1Year}
                  />
                )}
              </Space>
            </div>
          )}
        </div> */}
        <Form layout="vertical" className="w-full">
          {children ? (
            children
          ) : (
            <Row gutter={[8, 8]} className="w-full">
              {hasSearch && (
                <Col span={colSpans ? colSpans[0] : renderColSpans()[0]}>
                  {/* <Space direction="vertical" className="w-full"> */}
                  {/* <p className="font-medium">Search</p> */}
                  <AppSearch
                    placeholder={searchPlaceholder}
                    value={searchValue}
                    onChange={(val) => {
                      setSearchValue(val);
                    }}
                    className="w-full"
                    formItemClassName={'mb-0'}
                  />
                  {/* </Space> */}
                </Col>
              )}
              {hasFilter && (
                <>
                  {customFilter ? (
                    customFilter
                  ) : (
                    <Col span={colSpans ? colSpans[1] : renderColSpans()[1]}>
                      <AppSelect
                        items={filterOptions}
                        defaultValue={defaultFilterOptions}
                        placeholder={filterPlaceholder}
                        title={filterPlaceholder}
                        onChange={(val) => {
                          setSelectedFilter(val);
                        }}
                        className="w-full"
                        label={filterLabel}
                        value={selectedFilter}
                        formItemClassName={'mb-0'}
                      />
                    </Col>
                  )}
                </>
              )}
              {hasDatePicker && (
                <Col span={colSpans ? colSpans[2] : renderColSpans()[2]}>
                  {/* <div className="flex items-center gap-2">
                  <Space direction="vertical" className="w-full">
                    <p className="font-medium">{timeLabel}</p> */}
                  {!rangePicker ? (
                    <Form.Item label={timeLabel} className="mb-0">
                      <DatePicker
                        format={picker === 'month' ? displayMonthFormat : displayFormat}
                        picker={picker}
                        value={time ? dayjs(time) : null}
                        placeholder={isString(timePlaceholder) ? timePlaceholder : ''}
                        // className={isBreak ? 'max-w-[150px]' : 'max-w-[200px]'}
                        className="w-full"
                        onChange={(date) => handleOnOk(date)}
                        allowClear={allowClear}
                        disabledDate={(currentDate) => {
                          if (currentDate.isAfter(dayjs(), 'day') && canDisableFutureDate) {
                            return true;
                          }
                          return false;
                        }}
                      />
                    </Form.Item>
                  ) : (
                    <AppRangePicker
                      date={isArray(time) && time.length === 2 ? time : null}
                      onOk={handleOnOk}
                      dateLimit={dateLimit}
                      label={timeLabel}
                      formItemClassName={'mb-0'}
                    />
                  )}
                  {/* </Space>
                </div> */}
                </Col>
              )}
            </Row>
          )}
        </Form>

        {hasActionButtons && (
          <div className="flex gap-2">
            {
              <>
                <Button onClick={handleQuery} type="primary">
                  <span className="text-sm">Search</span>
                </Button>
                <Button onClick={handleReset}>
                  <span className="text-sm">Reset</span>
                </Button>
                {customActionButtons}
              </>
            }
          </div>
        )}
      </Flex>
    </Space>
  );
}

export default AppTableQuery;
